import cn from "classnames";
import { useColumnSizeProps } from "../../hooks";
import { CardProps } from "./Card";

export const useCardProps = (props: CardProps) => {
  const { active, className, padding, stacked, ...rest } =
    useColumnSizeProps(props);

  const output: string = cn(
    "card",
    {
      "card-active": active,
      "card-stacked": stacked,
      [`card-${padding}`]: padding,
    },
    className
  );

  return { className: output, ...rest };
};
